import * as Mailcheck from "mailcheck";

const DOMAINS: Array<string> = ["163.com", "accenture.com", "alice.com", "alice.it", "aliceposta.it", "ansa.it",
    "aol.com", "aol.it", "apss.tn.it", "aruba.it", "ausl.bologna.it", "awn.it", "beniculturali.it", "blu.it", "bluemail.ch",
    "bluewin.ch", "bnlmail.com", "campus.unimib.it", "ccgenova.com", "cheapnet.it", "circuitocinema.com", "cisl.it",
    "comune.bologna.it", "comune.milano.it", "comune.udine.it", "cro.it", "dipccroma.com", "edu.ti.ch", "email.com",
    "email.it", "enea.it", "enel.com", "eni.com", "esteri.it", "excite.it", "fao.org", "fastpiu.it", "fastweb.it",
    "fastwebmail.it", "fastwebnet.it", "fbk.eu", "feff2016.it", "free.fr", "gamil.com", "gdf.it", "gimail.com",
    "giustizia.it", "gmail.com", "gmx.ch", "gmx.com", "gmx.de", "gmx.net", "googlemail.com", "gop.it", "hispeed.ch",
    "hotmai.it", "hotmail.ch", "hotmail.co.uk", "hotmail.com", "hotmail.de", "hotmail.es", "hotmail.fr", "hotmail.it",
    "hsr.it", "icloud.com", "icloud.it", "ied.edu", "ilsole24ore.com", "infinito.it", "interfree.it", "intesasanpaolo.com",
    "inwind.it", "iol.it", "iperbole.bologna.it", "iss.it", "istat.it", "istruzione.it", "it.ibm.com", "it.pwc.com",
    "jumpy.it", "katamail.com", "kinemax.com", "kpmg.it", "libero.it", "lifegate.it", "liguriadigitale.it", "live.com",
    "live.fr", "live.it", "luiss.it", "lycos.com", "mac.com", "mail.com", "mail.polimi.it", "mail.ru", "mail.wind.it",
    "mailinator.com", "mclink.it", "me.com", "mediaset.it", "mondadori.it", "msn.com", "mvrht.com", "ngi.it",
    "notariato.it", "o2.pl", "oldcard.old", "oracle.com", "outlook.com", "outlook.it", "pacioli.net", "pnac.org",
    "polimi.it", "poste.it", "posteitaliane.it", "provincia.tn.it", "qq.com", "quipo.it", "rai.it", "rambler.ru",
    "rccl.com", "rcm.inet.it", "rcs.it", "regione.emilia-romagna.it", "regione.fvg.it", "repubblica.it", "rm.unicatt.it",
    "rocketmail.com", "seznam.cz", "simail.it", "skytv.it", "sogei.it", "stud.unifi.it", "studenti.unimi.it",
    "studenti.uniroma1.it", "studenti.unitn.it", "studio.unibo.it", "sunrise.ch", "supereva.it", "teatroudine.it",
    "tele2.it", "telecomitalia.it", "teletu.it", "tempmail.it", "tesoro.it", "ticino.com", "tim.it", "tin.it", "tiscali.it",
    "tiscalinet.it", "trbvm.com", "unibo.it", "unibocconi.it", "unicatt.it", "unicredit.eu", "unicreditgroup.eu",
    "unige.it", "unimi.it", "unimib.it", "uninsubria.it", "unipolsai.it", "unipv.it", "uniroma1.it", "uniroma2.it",
    "uniroma3.it", "unitn.it", "units.it", "uniud.it", "usi.ch", "virgilio.it", "vodafone.com", "vodafone.it", "web.de",
    "wfp.org", "whirlpool.com", "wp.pl", "yahoo.co.uk", "yahoo.com.ar", "yahoo.com.br", "yahoo.com", "yahoo.de", "yahoo.es",
    "yahoo.fr", "yahoo.gr", "yahoo.it", "yandex.ru", "yhaoo.it", "ymail.com", "yopmail.com"];

interface Suggestion { address: string; domain: string; full: string; }

function validate_field(email: string, suggestion_field?: string) {
    Mailcheck.run({
        email: email,
        domains: DOMAINS,
        suggested: function(suggestion: Suggestion) {
            if (!suggestion_field) { return false; }
            let element = document.querySelector(suggestion_field);
            if (element) { element.innerHTML = `Forse intendevi: <strong>${suggestion.full}</strong>`; }
        },
        empty: function() {
            if (!suggestion_field) { return false; }
            let element = document.querySelector(suggestion_field);
            if (element) { element.innerHTML = ""; }
        }
    });
}

let email_fields = document.querySelectorAll("input[type='email']");

[].forEach.call(email_fields, function(el: Element) {
    let query_suggestion_field = el.getAttribute("data-suggestion");

    if (query_suggestion_field) {
        el.addEventListener("blur", function() {
            if (!this.value.includes("@")) { return false; }
            validate_field(this.value, query_suggestion_field);
        });
    }
});
